export const BlogData = [
  {
    id: 1,
    url: "/blog-details",
    img: "images/blog-img_1.png",
    title: "Why you need to seperate business...",
    desc: "The reason for them and how to open a Brass acow to open a Brow to open a Brow to open ...",
  },
  {
    id: 2,
    url: "/blog-details",
    img: "images/blog-img_2.png",
    title: "Working on the right idea",
    desc: "How to figure out the right business for you. figure out the right business for you ....",
  },
  {
    id: 3,
    url: "/blog-details",
    img: "images/blog-img_3.png",
    title: "What you need to know about busi...",
    desc: "How business credit can work for you. How to figure out the right business for you....",
  },
];

export const CustomSlideText = [
  {
    id: 1,
    title: "Comprehensive Portfolio Management",
    desc: "We Segregate Your Speculative, Short & Long Term Transaction.",
  },
  {
    id: 2,
    title: "Intelligent Importing",
    desc: "Import All Your Transactions in Equity, F&O & Currency etc",
  },
  {
    id: 3,
    title: "Real-Time Market Insights",
    desc: "We Manage Impact Of Corporates Action On Your Investment.",
  },
  {
    id: 4,
    title: "Automated Accounting",
    desc: "We Manage Advisor , Broker & Demat A/c Wise Transaction",
  },
  {
    id: 5,
    title: "Seamless Integration",
    desc: "Seamless Integration",
  },
];

export const CustomSlideImg = [
  {
    id: 1,
    img: "images/image-slider.png",
  },
  {
    id: 2,
    img: "images/image-slider.png",
  },
  {
    id: 3,
    img: "images/image-slider.png",
  },
  {
    id: 4,
    img: "images/image-slider.png",
  },
  {
    id: 5,
    img: "images/image-slider.png",
  },
];

export const CustomTextImg = [
  {
    id: 1,
    cont: "i4invest is a premium investment management software.Since its launch, it has efficiently organized our family's diverse investment in shares & Mutual Funds,along with capital gain reports.",
    desc: "- Jayendra Saxena, Investor",
    imglogo: "images/odu-img.png",
  },
  {
    id: 2,
    cont: "Having used i4invest, I am satisfied with its user-friendly interface and exceptional support services.capital gain and loss calculations are accurate, and I have recommended it to all my C.A. friends.",
    desc: "- Heenal Madhu, CA.",
    imglogo: "images/odu-img.png",
  },
  {
    id: 3,
    cont: "i4invest is indispensable for individuals/families managing diverse asset classes, whether as investors, custodians, or service providers like stock brokers or Mutual Fund distributors.It is the only software that proactively adapts to evolving Indian Capital Market regulations.For instance, it automatically calculates Grandfathered Long Term Capital gains without requiring additional data.The outstanding service complements the exceptional product.Great work.",
    desc: "- Rupesh, Investment Consultant.",
    imglogo: "images/odu-img.png",
  },
  {
    id: 4,
    cont: "I have been using i4invest for the last few months, it is great product for investors. It has all required reports and analysis.I have recommended it to quite a few of my friends.",
    desc: "- Prasoon Jantra, Investor",
    imglogo: "images/odu-img.png",
  },
  {
    id: 5,
    cont: "Please continue your proactive and professional technical support, commendable work, and kindly convey my appreciation to your superlative team.",
    desc: "- Dina Shah, Inford Holdings",
    imglogo: "images/odu-img.png",
  },
  {
    id: 6,
    cont: "i4invest is an outstanding software,it simplifies post investments, transaction management issues across various asset classes. The convenient transaction import feature saves significant time and effort. The support provided by the staff is exceptional. They guided me through the initial stages and promptly addressed my issues, no matter how minor, often responding within hours. Best wishes to the dedicated i4invest team!",
    desc: "- Aarav Jaisingh, Tanco Investments Managers",
    imglogo: "images/odu-img.png",
  },
];

export const IntegratedData = [
  {
    id: 1,
    img: "images/Slider-img-1.jpg",
  },
  {
    id: 2,
    img: "images/Slider-img-2.jpg",
  },
  {
    id: 3,
    img: "images/Slider-img-3.jpg",
  },
];

export const FooterSupport = [
  {
    id: 1,
    path: "/",
    desc: "Help center",
  },
  {
    id: 2,
    path: "/contact",
    desc: "Contact us",
  },
  {
    id: 3,
    path: "/terms-of-use",
    desc: "Terms of use",
  },
  {
    id: 4,
    path: "/",
    desc: "Legal",
  },
  {
    id: 5,
    path: "/privacy-policy",
    desc: "Privacy policy",
  },
];

export const AboutLeaderWrapper = [
  {
    id: 1,
    img: "images/Vishal-Dalal-img.jpg",
    title: "Vishal Dalal",
    desc: "Founder Director",
    face: "images/facebook.png",
    twiter: "images/twiter_1.png",
    linked: "images/linked.png",
  },
  {
    id: 2,
    img: "images/Trusha-Dalal-img.jpg",
    title: "Trusha Dalal",
    desc: "Director - Operation & Banking",
    face: "images/facebook.png",
    twiter: "images/twiter_1.png",
    linked: "images/linked.png",
  },
];

export const AboutTeamWrapper = [
  {
    id: 1,
    img: "images/satish-img.jpg",
    title: "Satish",
    desc: "Sr. Business Analyst",
    face: "images/facebook.png",
    twiter: "images/twiter_1.png",
    linked: "images/linked.png",
  },
  {
    id: 2,
    img: "images/Ashutosh-img.jpg",
    title: "Ashutosh",
    desc: "Project Manager & Backend Developer",
    face: "images/facebook.png",
    twiter: "images/twiter_1.png",
    linked: "images/linked.png",
  },
  {
    id: 3,
    img: "images/Sagar-img.jpg",
    title: "Sagar",
    desc: "Backend Developer",
    face: "images/facebook.png",
    twiter: "images/twiter_1.png",
    linked: "images/linked.png",
  },
  {
    id: 4,
    img: "images/lovepreet-img.jpg",
    title: "Lovepreet",
    desc: "Backend Developer",
    face: "images/facebook.png",
    twiter: "images/twiter_1.png",
    linked: "images/linked.png",
  },
  {
    id: 5,
    img: "images/sahil-img.jpg",
    title: "Sahil",
    desc: "Frontend Developer",
    face: "images/facebook.png",
    twiter: "images/twiter_1.png",
    linked: "images/linked.png",
  },
 
];
